/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoAddDriverContactInput = {
    clientMutationId?: string | null;
    format: string;
    salutation: string;
    firstName: string;
    lastName: string;
    email?: string | null;
    businessPhone?: string | null;
    company?: string | null;
    country: string;
    place?: string | null;
    postcode?: string | null;
    address?: string | null;
    state?: string | null;
    language?: string | null;
    contactType?: string | null;
    roles?: Array<string> | null;
    eori?: string | null;
    vat?: string | null;
};
export type DriverContactAddMutationVariables = {
    input: infoAddDriverContactInput;
};
export type DriverContactAddMutationResponse = {
    readonly infoAddDriverContact: {
        readonly clientMutationId: string | null;
    } | null;
};
export type DriverContactAddMutation = {
    readonly response: DriverContactAddMutationResponse;
    readonly variables: DriverContactAddMutationVariables;
};



/*
mutation DriverContactAddMutation(
  $input: infoAddDriverContactInput!
) {
  infoAddDriverContact(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoAddDriverContactPayload",
    "kind": "LinkedField",
    "name": "infoAddDriverContact",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DriverContactAddMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DriverContactAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bec85bc653e9c8320b06fe0dbd98988a",
    "id": null,
    "metadata": {},
    "name": "DriverContactAddMutation",
    "operationKind": "mutation",
    "text": "mutation DriverContactAddMutation(\n  $input: infoAddDriverContactInput!\n) {\n  infoAddDriverContact(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd2b5ee09bbc2c776c0c2148d1a530b50';
export default node;
